import React from 'react';
import ActiveLink from '../../utils/active-link';

/* eslint-disable */
const PanelListItemDuo = props => (
  <ActiveLink to={props.url} onClick={props.handleClick}>
    <li className={ props.image ? 'panel-list-item panel-list-item-duo panel-list-item-duo-image' : 'panel-list-item panel-list-item-duo'}>
      { props.image &&
          <div className="list-item-image avatar avatar-medium">
            <div className="avatar-container">
              <img className="avatar-image" alt="" src={props.image} />
            </div>
          </div>
      }
      <div className="list-item-content">
        <h2>{props.title}</h2>
        { props.meta ? <span className="meta">{props.meta}</span> : ''}
        { props.meta === props.info ? '' : <span>{props.info}</span>}
      </div>
      <div className="list-item-action">
        { props.check ? <i className={ 'icon icon-check-' + props.checkClass } /> : '' }
        { props.button ? <span className={ props.buttonClass } onClick={ props.buttonAction }>{ props.buttonText }</span> : '' }
        { !props.check && !props.button ? <i className='icon icon-arrow-right' /> : '' }
      </div>
    </li>
  </ActiveLink>
);

export default PanelListItemDuo;



// WEBPACK FOOTER //
// ./src/components/layout/panel-list-item-duo/index.jsx